export const INCENTIVE_SOURCE = {
  MYSTERY_SHOP_PHONE: 'mystery_shop_phone',
  MYSTERY_SHOP_EMAIL_FOLLOW_UP: 'mystery_shop_email_follow_up',
  WEBSITE: 'website',
  EMAIL_MARKETING: 'email_marketing',
};

export const INCENTIVE_SOURCE_LABELS: Record<string, string> = {
  [INCENTIVE_SOURCE.MYSTERY_SHOP_PHONE]: 'Mystery Shop Phone',
  [INCENTIVE_SOURCE.MYSTERY_SHOP_EMAIL_FOLLOW_UP]: 'Mystery Shop Email Follow Up',
  [INCENTIVE_SOURCE.WEBSITE]: 'Website',
  [INCENTIVE_SOURCE.EMAIL_MARKETING]: 'Email Marketing',
};

export const INCENTIVE_SOURCE_SHOP_REQUEST_OPTIONS = [
  { value: INCENTIVE_SOURCE.MYSTERY_SHOP_PHONE, label: INCENTIVE_SOURCE_LABELS[INCENTIVE_SOURCE.MYSTERY_SHOP_PHONE] },
  {
    value: INCENTIVE_SOURCE.MYSTERY_SHOP_EMAIL_FOLLOW_UP,
    label: INCENTIVE_SOURCE_LABELS[INCENTIVE_SOURCE.MYSTERY_SHOP_EMAIL_FOLLOW_UP],
  },
  { value: INCENTIVE_SOURCE.WEBSITE, label: INCENTIVE_SOURCE_LABELS[INCENTIVE_SOURCE.WEBSITE] },
];

export const INCENTIVE_SOURCE_ALL_OPTIONS = [
  ...INCENTIVE_SOURCE_SHOP_REQUEST_OPTIONS,
  { value: INCENTIVE_SOURCE.EMAIL_MARKETING, label: INCENTIVE_SOURCE_LABELS[INCENTIVE_SOURCE.EMAIL_MARKETING] },
];

export const INCENTIVE_MODAL_TYPE = {
  CREATE: 'create',
  EDIT: 'edit',
};

export const INCENTIVE_MODAL_LABELS = {
  [INCENTIVE_MODAL_TYPE.CREATE]: {
    title: 'Add Incentive',
    action: 'Save',
  },
  [INCENTIVE_MODAL_TYPE.EDIT]: {
    title: 'Edit Incentive',
    action: 'Save',
  },
};
